import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
type LoadingProps = {
  count: number;
};
const Loading = t0 => {
  const $ = _c(2);
  const {
    count
  } = t0;
  let t1;
  if ($[0] !== count) {
    t1 = <>{Array.from({
        length: count
      }).map(_temp)}</>;
    $[0] = count;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Loading;
function _temp() {
  return <Shimmer height="23px" width="180px" key={Math.random()} />;
}